import React from 'react';
import {Link, browserHistory} from 'react-router';
import './profile_navbar.less';
import Select from 'react-select';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';


class ProfileNavBarDektop extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        const {props} = this;
        let {userData} = props;
        const userProfileImage = props.userData.imageUrl || "../../public/images/user_placeholder.svg";
        return (
            <div className="account-navbar-wrap">
              <Link to="/profile" className="user-details-wrap" activeClassName="active-account-navbar-elm">
                <div className = "user-profile-wrap">
                  <img className="user-profile-img-wrap" src={userProfileImage}/>
                  <div className="user-profile-details-wrap">{userData.name} {userData.isVerified && <div className="account-verified-elm"></div>}</div>
                </div>
              </Link>

              <div className="user-details-hr"></div>
                <div className="account-navbar-elm-wrap">
                  <Link to="/my-trips" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                    <div>My Trips</div>
                  </Link>
                </div>
              <div className="account-navbar-elm-wrap">
                <Link to="/account" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Account</div>
                </Link>
                <Link to="/account-payment" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Payment</div>
                </Link>
                <Link to="/notifications" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Notifications</div>
                </Link>
                <Link to = "/id-verification"className="account-navbar-elm cf cursor-default" activeClassName="active-account-navbar-elm">
                  <div className="f-l">
                    ID Verification
                  </div>
                  {userData.isVerified &&<div className="f-r align-middle navbar-details-val">
                    <div  className="account-verified-elm"></div><div className="account-verified-text-elm">Verified</div>
                  </div>}
                </Link>
              </div>
              <div className="account-navbar-elm-wrap">
                <Link className="account-navbar-elm cursor-default" activeClassName="active-account-navbar-elm">
                  <div className="f-l">
                    Account Credit
                  </div>
                  <div className="f-r navbar-details-credit">
                    ${userData.creditAmount ? userData.creditAmount : 0}
                  </div>
                </Link>
                <Link to="/promocode" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Enter Promo Code</div>
                </Link>
                <Link to="/invite-friends"className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Invite Friends - Get 20% Off</div>
                </Link>
              </div>
              <div className="account-navbar-elm-wrap">
                <Link to="/how-it-works" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>How AWB Works</div>
                </Link>
                <Link to="/contact-support"className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Contact Support</div>
                </Link>
                <Link to="/send-feedback"className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                  <div>Send Feedback</div>
                </Link>
                {/*
                // <Link to="/legal-content" className="account-navbar-elm" activeClassName="active-account-navbar-elm">
                //   <div>Legal</div>
                // </Link> */}
              </div>
              <div className="account-navbar-elm-wrap">
                <div className="account-navbar-elm legal-header">Legal</div>
                <Link to="/cookie-policy" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                  <div>Cookie Policy</div>
                </Link>
                <Link to="/privacy-policy" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                  <div>Privacy Policy</div>
                </Link>
                <Link to="/terms-and-conditions" target="_blank" className="account-navbar-elm legal-sub-hdr" activeClassName="active-account-navbar-elm">
                  <div>Terms and Conditions</div>
                </Link>
              </div>
            </div>
        )
    }
}

ProfileNavBarDektop.propTypes = {
  pathname: React.PropTypes.string.isRequired,
  userData: React.PropTypes.object.isRequired
};

module.exports = ProfileNavBarDektop;



// WEBPACK FOOTER //
// app/profile/profile_navbar/profile_navbar_desktop.jsx